import { Pipe, PipeTransform } from '@angular/core';
import { StoryblokLink } from '../storyblok-types';

export const convertStoryblokLinkToUrl = (link: StoryblokLink, linkMap?: Map<string, string>): string => {
  if (!link) return;
  const url = (() => {
    if (!link) return '';
    if (link.linktype === 'url') return link.url;
    if (link.linktype === 'story' && link.cached_url) {
      return '/' + (linkMap?.get(link.id) || link.cached_url);
    }
    return '';
  })().replace(/\/$/, ''); // Remove trailing slash
  if (url === '/home') return '';
  if (link.anchor) return url + '#' + link.anchor;
  return url;
};

@Pipe({
  name: 'storyblokLink',
  standalone: true,
})
export class storyblokLinkPipe implements PipeTransform {
  transform(value: StoryblokLink): string {
    return convertStoryblokLinkToUrl(value);
  }
}
